<template>
  <div>
    <div class="header-image pb-5">
      <div
        class="w-100 text-center white--text font-weight-bold header-text py-4"
      >
        Welcome
        <div v-if="user" class="d-inline-block">, {{ user.full_name }}</div>
        . Quickly search for any cards or passes.
      </div>

      <search-bar @searchedFile="fileSearch" />
    </div>

    <!-- <div fluid-grow alt="banner" class="header-image rounded-0"></div> -->

    <b-container v-show="!searchedFile" class="custom-container mt-5">
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row><h4 class="font-weight-bold">Files</h4></b-row>
            <b-row class="file-menu-container px-3">
              <b-col sm="12" md="6" lg="6" class="mb-0 d-flex align-items-end">
                <b-button
                  class="tab mb-0 font-weight-bold py-4"
                  variant="transparent"
                  @click="activeTab = 'files'"
                >
                  My Files
                  <div
                    class="no-active-tab mt-2 mx-auto"
                    :class="activeTab === 'files' ? 'active-tab' : ''"
                  ></div>
                </b-button>
                <b-button
                  v-if="user && user.user_type === 'business_admin'"
                  class="tab mb-0 font-weight-bold py-4"
                  variant="transparent"
                  @click="activeTab = 'shared'"
                >
                  Shared With Me
                  <div
                    class="no-active-tab mt-2 mx-auto"
                    :class="activeTab === 'shared' ? 'active-tab' : ''"
                  ></div>
                </b-button>
              </b-col>
              <b-col
                sm="12"
                md="6"
                lg="6"
                class="d-flex justify-content-center justify-content-md-end py-3"
              >
                <!-- <b-button
                  @click="bulkDownload()"
                  variant="outlined"
                  class="float-sm-right font-weight-bold gray--2"
                >
                  <b-icon icon="download"></b-icon> Download
                </b-button> -->
                <b-button-group
                  v-show="checkedFiles.length"
                  variant="outlined"
                  class="my-md-auto my-2 float-sm-right font-weight-bold gray--2"
                  :disabled="loading"
                >
                  <b-dropdown
                    :text="`Selected ${checkedFiles.length} item/s`"
                    variant="outlined"
                    class="gray--2"
                  >
                    <b-dropdown-item @click="bulkDownload">
                      <b-icon
                        icon="download"
                        class="mr-2"
                        aria-hidden="true"
                      ></b-icon>
                      Download Selected Item/s
                    </b-dropdown-item>
                    <!-- <b-dropdown-item @click="shareFiles">
                      <b-icon
                        icon="cursor"
                        class="mr-2"
                        aria-hidden="true"
                      ></b-icon>
                      Share Selected File/s
                    </b-dropdown-item> -->
                  </b-dropdown>
                  <b-button
                    right
                    variant="outlined"
                    class="gray--2"
                    @click="clearSelectedFiles"
                  >
                    Clear
                  </b-button>
                </b-button-group>
              </b-col>
            </b-row>
          </b-container>
          <b-card border-variant="light" bg-variant="light" body-class="px-0">
            <file-list
              :files="files"
              ref="fileList"
              @selectedFiles="filesSelected"
              @shareSingleFile="shareFiles"
            />
            <b-pagination
              v-model="currentPage"
              :total-rows="filesMeta.total"
              :per-page="filesMeta.per_page"
              class="px-3 pt-4"
              align="right"
            ></b-pagination>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-container v-show="searchedFile" class="custom-container mt-5">
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col
                sm="12"
                md="6"
                lg="6"
                class="my-2 mb-5 my-md-0 mb-md-0 d-flex align-items-end"
              >
                <h4 class="font-weight-bold">All Search Results</h4>
              </b-col>
              <b-col
                sm="12"
                md="6"
                lg="6"
                class="d-flex justify-content-center justify-content-md-end align-items-end"
              >
                <!-- <b-button
                  @click="bulkDownload()"
                  variant="outlined"
                  class="float-sm-right font-weight-bold gray--2"
                >
                  <b-icon icon="download"></b-icon> Download
                </b-button> -->
                <b-button-group
                  v-show="checkedFiles.length"
                  variant="outlined"
                  class="float-sm-right font-weight-bold gray--2"
                  :disabled="loading"
                >
                  <b-dropdown
                    :text="`Selected ${checkedFiles.length} item/s`"
                    variant="outlined"
                    class="gray--2"
                  >
                    <b-dropdown-item @click="bulkDownload">
                      <b-icon
                        icon="download"
                        class="mr-2"
                        aria-hidden="true"
                      ></b-icon>
                      Download Selected Item/s
                    </b-dropdown-item>
                    <!-- <b-dropdown-item @click="shareFiles">
                      <b-icon
                        icon="cursor"
                        class="mr-2"
                        aria-hidden="true"
                      ></b-icon>
                      Share Selected File/s
                    </b-dropdown-item> -->
                  </b-dropdown>
                  <b-button
                    right
                    variant="outlined"
                    class="gray--2"
                    @click="clearSelectedFiles"
                  >
                    Clear
                  </b-button>
                </b-button-group>
              </b-col>
            </b-row>
          </b-container>
          <b-card border-variant="light" bg-variant="light" body-class="px-0">
            <file-list
              :files="files"
              ref="searchedFileList"
              @selectedFiles="filesSelected"
              @shareSingleFile="shareFiles"
            />
          </b-card>
          <p v-if="searchedFile && !files.length" class="px-2">
            No File/s found.
          </p>
        </b-col>
      </b-row>
    </b-container>
    <subscription-modal v-model="show" @close="show = false" />
    <share-file-modal
      :showShareFiles="showShareFiles"
      :selectedFiles="checkedFiles"
      :fileShares="fileShares"
      @closeShareFileModal="showShareFiles = false"
      @fileShareResponsePrompt="shareFileResponsePrompt"
      @reloadFileList="getFileList"
    />

    <b-alert
      class="custom-alert"
      :show="dismissCountDown"
      :class="{
        'bg-danger border-danger': alertType === 'danger'
      }"
      dismissible
      fade
      :variant="alertType"
      @dismiss-count-down="countDownChanged"
    >
      {{ alertMsg }}
    </b-alert>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { find } from 'lodash'
import SearchBar from '@/components/SearchBar'
import FileList from '@/components/lists/FileList'
import SubscriptionModal from '@/components/modals/SubscriptionModal'
import ShareFileModal from '@/components/modals/ShareFileModal'

export default {
  components: {
    SearchBar,
    FileList,
    SubscriptionModal,
    ShareFileModal
  },

  data() {
    return {
      loading: false,
      checkedFiles: [],
      searchedFile: '',
      show:
        this.$route.params.show === undefined ? false : this.$route.params.show,
      showShareFiles: false,
      fileShares: [],
      dismissCountDown: 0,
      alertMsg: null,
      alertType: 'primary',
      currentPage: 1,
      activeTab: 'files'
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    ...mapGetters('file', ['files', 'filesMeta'])
  },

  methods: {
    ...mapActions({
      getFiles: 'file/getFiles',
      getSearchedFiles: 'file/getSearchedFiles',
      getSharedFiles: 'file/getSharedFiles'
    }),
    async getFileList(page = 1) {
      this.loading = true
      this.clearSelectedFiles()
      await this.getFiles(page)
      this.loading = false
    },
    filesSelected(files) {
      this.checkedFiles = files
    },
    clearSelectedFiles() {
      this.checkedFiles = []

      this.$refs.fileList.clearFilesSelected()
    },
    async bulkDownload() {
      await this.$api
        .get('download-bulk-files', {
          responseType: 'blob',
          params: { files: this.checkedFiles }
        })
        .then(data => {
          const name = this.user.full_name
          const filename = `${name}.zip`
          const url = URL.createObjectURL(
            new Blob([data.data], {
              type: 'application/zip'
            })
          )
          const link = document.createElement('a')

          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
        .catch(e => {
          setTimeout(e => {
            this.$emit('showAlert', 'downloaded unsuccessfully.')
          }, 5000)
        })
    },
    async fileSearch(name) {
      this.searchedFile = name
      this.clearSelectedFiles()

      if (!this.searchedFile) {
        await this.getFileList()
      } else {
        await this.getSearchedFiles(this.searchedFile)
          .then(res => {})
          .catch(error => {
            this.$emit('showAlert', 'error while searching for file/s: ', error)
          })
      }
    },
    shareFiles() {
      let fileShared = find(this.files, { id: this.checkedFiles[0] })
      this.fileShares = fileShared.file_shares
      this.showShareFiles = true
    },
    async shareFileResponsePrompt(res) {
      if (res.success) {
        await this.getFileList()

        this.alertMsg =
          'File shared successfully to selected Business Admin emails: ' +
          res.data.success.join(', ')

        this.dismissCountDown = 15

        return
      } else {
        this.alertType = 'danger'

        if (res.status === 402 || res.status === 422) {
          if (res.message) {
            this.alertMsg = res.message
          } else {
            this.alertMsg = 'File shared unsuccessful!'
          }
        } else {
          this.alertMsg =
            'Something went wrong while submitting the share file email!'
        }
      }

      this.dismissCountDown = 5
    },
    showAlert() {
      this.dismissCountDown = 5
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    clearAlert() {
      this.dismissCountDown = 0
      this.alertMsg = null
      this.alertType = 'primary'
    }
  },
  mounted() {
    if (
      this.user &&
      this.user.user_type === 'business_admin' &&
      this.$route.params.tab
    ) {
      this.activeTab = 'shared'
    } else {
      this.getFileList()
    }
  },
  watch: {
    searchedFile(newVal, oldVal) {
      if (!newVal) this.getFileList()
    },
    currentPage(value) {
      if (this.activeTab === 'files') {
        this.getFileList(value)
      } else {
        this.getSharedFiles(value)
      }
    },
    activeTab(value) {
      this.currentPage = 1
      if (value === 'files') {
        this.getFileList()
      } else {
        this.getSharedFiles(this.currentPage)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-image {
  // top: 88px;
  // height: 280px;
  background: transparent linear-gradient(130deg, #006cff 0%, #00429d 100%) 0%
    0% no-repeat padding-box;
}

.header-text {
  // top: 136px;
  margin-top: 88px;
  font-size: 35px;
}

/deep/ nav.center-screen {
  margin-top: 0;
}

.file-menu-container {
  background: white;
  // height: 88px;
  border: 1px solid #b6c3d94d;
  border-radius: 8px;
}

.tab {
  height: 100%;

  &:hover,
  &:focus,
  &:active {
    background-color: #eaf3ff !important;
    color: #006cff !important;
  }
}
</style>
